import { AlertTriangle } from 'lucide-react';

interface DuplicateNoticeProps {
  originalFilename?: string;
  onDismiss?: () => void;
}

export function DuplicateNotice({ originalFilename, onDismiss }: DuplicateNoticeProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-3 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg">
      <AlertTriangle size={18} className="text-orange-500 dark:text-orange-400 flex-shrink-0" />
      <div className="flex-1 text-sm text-orange-800 dark:text-orange-300">
        <span className="font-medium">Duplicate detected.</span>{' '}
        This document has identical content to{' '}
        {originalFilename ? (
          <span className="font-medium">{originalFilename}</span>
        ) : (
          'an existing document'
        )}
        . It has been uploaded for audit trail purposes.
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-orange-500 dark:text-orange-400 hover:text-orange-700 dark:hover:text-orange-300 text-sm font-medium"
        >
          Dismiss
        </button>
      )}
    </div>
  );
}
